module.exports = __webpack_public_path__ + "img/C04TechSuperTraining_ua.6db0e877.webp";